import { useEffect } from 'react'
import './ChartBar.scss'
import Chart from 'chart.js'
import PropTypes from 'prop-types'

export const CharBar = ({ chartID, bgColor }) => {
	useEffect(() => {
		if (chartID) {
			const context = document.getElementById(chartID)
			new Chart(context, {
				type: 'bar',
				data: {
					labels: [
						'January',
						'February',
						'March',
						'April',
						'May',
						'June',
						'July',
						'August',
						'September',
						'October',
						'November',
						'December',
						'January',
						'February',
						'March',
						'April',
					],
					datasets: [
						{
							label: 'User online',
							backgroundColor: '#e55353',
							borderColor: 'rgba(255, 99, 132, 0.2)',
							data: [
								78,
								81,
								80,
								45,
								34,
								12,
								40,
								85,
								65,
								23,
								12,
								98,
								34,
								84,
								67,
								82,
							],
							barPercentage: 0.6,
						},
						{
							label: 'User register',
							backgroundColor: '#ffc100',
							borderColor: 'rgba(255, 99, 132, 0.2)',
							data: [
								28,
								30,
								20,
								35,
								14,
								62,
								20,
								95,
								25,
								13,
								22,
								38,
								24,
								14,
								77,
								82,
							],
							barPercentage: 0.6,
						},
						{
							label: 'User register',
							backgroundColor: '#0093e9',
							borderColor: 'rgba(255, 99, 132, 0.2)',
							data: [
								28,
								30,
								20,
								35,
								14,
								62,
								20,
								95,
								25,
								13,
								22,
								38,
								24,
								14,
								77,
								82,
							],
							barPercentage: 0.6,
						},
					],
				},
			})
		}
	}, [chartID])

	return <canvas id={chartID} className={bgColor}></canvas>
}

CharBar.propTypes = {
	chartID: PropTypes.string,
	bgColor: PropTypes.string,
}
